"use strict";

exports.__esModule = true;

exports.default = function () {
  return {
    manipulateOptions: function manipulateOptions(opts, parserOpts) {
      parserOpts.plugins.push("asyncFunctions");
    }
  };
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-plugin-syntax-async-functions/lib/index.js
 ** module id = 508
 ** module chunks = 0
 **/